import {Box, Card, CardActions, CardContent, Typography} from '@mui/material';
import Button from '@mui/material/Button';
import type * as React from 'react';

type Props = {
    login : () => void;
};

const AuthError = ({login} : Props) : React.ReactElement => {
    return <Box sx={{
        display: 'flex',
        width: '100%',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
    }}>
        <Card>
            <CardContent>
                <Typography variant="h2" gutterBottom={true}>Sign In</Typography>
                <Typography variant="body1">
                    An error occurred during authentication, please try again!
                </Typography>
            </CardContent>
            <CardActions>
                <Button size="small" color="secondary" onClick={login}>
                    Sign in
                </Button>
            </CardActions>
        </Card>
    </Box>;
};

export default AuthError;
